import { Modules } from '@mangosoft/mango-layout';

export const modulesSidebar: Modules[] = [
	{
		id: 1,
		icon: 'conveyor_belt',
		title: 'system-modules',
		route: '/system-modules',
		status: true,
	},
	{
		id: 2,
		icon: 'badge',
		title: 'Clients',
		route: '/clients',
		status: true,
	},
	{
		id: 3,
		icon: 'settings_account',
		title: 'Roles',
		route: '/roles',
		status: true,
	},
	{
		id: 4,
		icon: 'face',
		title: 'Users',
		route: '/users',
		status: true,
	},
	{
		id: 5,
		icon: 'group',
		title: 'Grupos',
		route: '/groups',
		status: true,
	},
];
